// src/lib/store.js
import { create } from 'zustand';
import { supabase, getConfiguracion } from './supabase';

export const useStore = create((set, get) => ({
  // Auth
  user: null,
  session: null,
  setUser: (user) => set({ user }),
  setSession: (session) => set({ session }),

  // Config
  config: {},
  loadConfig: async () => {
    const config = await getConfiguracion();
    set({ config });
  },

  // Pagos
  pagos: [],
  pagosLoading: false,
  loadPagos: async () => {
    set({ pagosLoading: true });
    const { data } = await supabase
      .from('pagos')
      .select('*, afiliados(nombres, apellidos, cedula)')
      .order('created_at', { ascending: false });
    set({ pagos: data || [], pagosLoading: false });
  },

  // Notificaciones UI
  notifications: [],
  addNotification: (notif) => {
    const id = Date.now();
    set(state => ({ notifications: [...state.notifications, { ...notif, id }] }));
    setTimeout(() => {
      set(state => ({ notifications: state.notifications.filter(n => n.id !== id) }));
    }, 4000);
  },

  // UI State
  // En escritorio (>=1024px) el menú arranca expandido; en móvil arranca cerrado (es un cajón superpuesto)
  sidebarOpen: typeof window === 'undefined' ? true : window.innerWidth >= 1024,
  toggleSidebar: () => set(state => ({ sidebarOpen: !state.sidebarOpen })),
  activeModal: null,
  setActiveModal: (modal) => set({ activeModal: modal }),
}));
